import { Route } from '@angular/router';
import ClientLayoutComponent from './layout/client-layout/client-layout.component';
import CustomerLayoutComponent from './pages/customer/components/customer-layout/customer-layout.component';
import GalleryLayoutComponent from './pages/gallery/components/gallery-layout/gallery-layout.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: ClientLayoutComponent,
    children: [
      {
        path: '',
        data: { title: '홈' },
        loadComponent: () => import('./pages/home/home.page'),
      },
      {
        path: 'directions',
        data: { title: '길안내' },
        loadComponent: () => import('./pages/directions/directions.page'),
      },
      {
        path: 'customer',
        component: CustomerLayoutComponent,
        children: [
          {
            path: '',
            redirectTo: 'notice',
            pathMatch: 'full',
          },
          {
            path: 'notice',
            data: { title: '공지사항' },
            loadComponent: () => import('./pages/customer/notice/notice.page'),
          },
          {
            path: 'notice/:id',
            data: { title: '공지사항 상세' },
            loadComponent: () =>
              import(
                './pages/customer/notice/notice-detail/notice-detail.page'
              ),
          },
          {
            path: 'faq',
            data: { title: '자주 묻는 질문' },
            loadComponent: () => import('./pages/customer/faq/faq.page'),
          },
        ],
      },
      {
        path: 'gallery',
        component: GalleryLayoutComponent,
        children: [
          {
            path: '',
            redirectTo: 'news',
            pathMatch: 'full',
          },
          {
            path: 'news',
            data: { title: '보도자료' },
            loadComponent: () => import('./pages/gallery/news/news.page'),
          },
          {
            path: 'news/:id',
            data: { title: '보도자료 상세' },
            loadComponent: () =>
              import('./pages/gallery/news/news-detail/news-detail.page'),
          },
          {
            path: 'photo-gallery',
            data: { title: '사진 갤러리', type: 'PHOTO' },
            loadComponent: () => import('./pages/gallery/gallery/gallery.page'),
          },
          {
            path: 'photo-gallery/:id',
            data: { title: '사진 갤러리 상세', type: 'PHOTO' },
            loadComponent: () =>
              import(
                './pages/gallery/gallery/gallery-detail/gallery-detail.page'
              ),
          },
          {
            path: 'video-gallery',
            data: { title: '동영상 갤러리', type: 'VIDEO' },
            loadComponent: () => import('./pages/gallery/gallery/gallery.page'),
          },
          {
            path: 'video-gallery/:id',
            data: { title: '동영상 갤러리 상세', type: 'VIDEO' },
            loadComponent: () =>
              import(
                './pages/gallery/gallery/gallery-detail/gallery-detail.page'
              ),
          },
        ],
      },
      {
        path: 'inquiry',
        children: [
          {
            path: '',
            data: { title: '홍보 제휴 문의' },
            loadComponent: () => import('./pages/inquiry/inquiry.page'),
          },
          {
            path: 'form',
            data: { title: '홍보 제휴 문의 작성 폼' },
            loadComponent: () =>
              import('./pages/inquiry/inquiry-form/inquiry-form.page'),
          },
        ],
      },
      {
        path: 'event',
        data: { title: '행사안내' },
        loadComponent: () => import('./pages/event/event.page'),
      },
      {
        path: 'registration',
        data: { title: '관람안내' },
        loadComponent: () => import('./pages/registration/registration.page'),
      },
      {
        path: 'policy',
        data: { title: '약관 및 정책' },
        loadComponent: () => import('./pages/policy/policy.page'),
      },
      {
        path: 'booth-application-form',
        data: { title: '참가 신청 폼' },
        loadComponent: () =>
          import('./pages/booth-application-form/booth-application-form.page'),
      },
      {
        path: 'registration-form',
        data: { title: '사전 등록 폼' },
        loadComponent: () =>
          import('./pages/registration-form/registration-form.page'),
      },
      {
        path: 'event/:id',
        data: { title: '행사 상세' },
        loadComponent: () => import('./pages/event-detail/event-detail.page'),
      },
      // 없는 경로 전부 홈으로
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];
